import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, signal } from '@angular/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

// Services
import { SearchService } from './../../../services/search.service'
import { UtilityService } from 'src/app/services/utility.service'

// Interfaces
import { IBaseComponent } from 'src/app/interfaces/components/component-base.interface'
import { IOneCallConfiguration } from 'src/app/interfaces/components/component-one-call.interface'
import { IComponentDevOptions } from 'src/app/modules/dev/dev.page'

export const OneCallComponentDefaults: IOneCallConfiguration = {
    type: 'one_call',
    display: true,
    key: '',
    number: '',
    label: '',
    icon: 'phone',
}

export const OneCallComponentDevOpts: IComponentDevOptions = {
    config: {
        ...OneCallComponentDefaults,
        number: '+13103609200',
        label: '1 (310) 360-9200'
    },
}

@Component({
    selector: '.ras-one-call',
    templateUrl: './one-call.component.html',
    styleUrls: ['./one-call.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OneCallComponent implements OnInit, OnDestroy, IBaseComponent {
    private $destroy = new Subject<void>()

    @Input() configuration: IOneCallConfiguration

    phoneNumber = signal('')
    phoneLabel = signal('')

    constructor(private searchService: SearchService) { }

    ngOnInit() {
        UtilityService.populateConfigDefaults(this.configuration, OneCallComponentDefaults)
        this.phoneNumber.set(this.configuration.number)
        this.phoneLabel.set(this.configuration.label)
        if (this.configuration.dataGroup) {
            this.searchService.requestData(this.configuration.dataGroup)
                .pipe(takeUntil(this.$destroy))
                .subscribe(data => {
                    const phone = data[this.configuration.key]
                    if (this.validatePhone(phone)) {
                        this.phoneNumber.set(phone)
                        this.phoneLabel.set(phone)
                    }
                })
        }
    }

    ngOnDestroy() {
        this.$destroy.next()
        this.$destroy.complete()
    }

    validatePhone(phone: string): boolean {
        if (phone) {
            // matches the following:
            /**
                +1 310-360-9200
                +44 (20) 1234 5678
                123-456-7890
                (123) 456-7890
                1234567890
             */
            const phoneRegex = /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/
            return phoneRegex.test(phone)
        }
        return false
    }
}
